import { isPrimitiveArrayControl, rankWith, schemaMatches, and } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { Unwrapped } from "@jsonforms/material-renderers";
import { Grid, Typography, FormHelperText } from "@mui/material";
const { MaterialIntegerControl } = Unwrapped;

/***
 * Custom range input. Create it in the schema with the following:
 * 
 *  radiusRange: {
        type: "array",
        range_min: 0,
        range_max: 100,
        items: { type: "integer", minimum: 0, maximum: 100 },
    }
 * 
 */

function validateInput(props) {
    let global_errors = [];
    let low_errors = [];
    let high_errors = [];

    // ensure_ordered defaults to true
    let ensure_ordered = props.schema.ensure_ordered ?? true;

    if (ensure_ordered && props.data[0] > props.data[1]) {
        global_errors.push("Low value must be less than high value");
    }

    if (props.data[0] < props.schema.range_min) {
        low_errors.push("Low value must be greater than or equal to " + props.schema.range_min);
    }
    if (props.data[0] > props.schema.range_max) {
        low_errors.push("Low value must be less than or equal to " + props.schema.range_max);
    }

    if (props.data[1] < props.schema.range_min) {
        high_errors.push("High value must be greater than or equal to " + props.schema.range_min);
    }
    if (props.data[1] > props.schema.range_max) {
        high_errors.push("High value must be less than or equal to " + props.schema.range_max);
    }

    return { global_errors, low_errors, high_errors };
}

export const rangeControl = (props) => {
    const schema = props.schema;
    const errors = validateInput(props);

    let low_props = Object.assign({}, props);
    low_props.data = props.data[0];
    low_props.handleChange = (ev, val) => {
        props.handleChange(ev, [val, props.data[1]]);
    };
    low_props.errors = errors.low_errors;

    let high_props = Object.assign({}, props);
    high_props.data = props.data[1];
    high_props.handleChange = (ev, val) => {
        props.handleChange(ev, [props.data[0], val]);
    };
    high_props.errors = errors.high_errors;

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h6">{props.label}</Typography>
                <Typography variant="caption">{`Min: ${schema.range_min} Max: ${schema.range_max}`}</Typography>
                <FormHelperText error={errors.global_errors.length > 0}>{errors.global_errors}</FormHelperText>
            </Grid>

            <Grid item xs={12}>
                <MaterialIntegerControl {...low_props} label={"low"} />
            </Grid>
            <Grid item xs={12}>
                <MaterialIntegerControl {...high_props} label={"high"} />
            </Grid>
        </Grid>
    );
};

export const rangeControlTester = rankWith(
    10,
    and(
        isPrimitiveArrayControl,
        schemaMatches((schema) => {
            return Object.prototype.hasOwnProperty.call(schema, "range_min") && Object.prototype.hasOwnProperty.call(schema, "range_max");
        })
    )
);
export default withJsonFormsControlProps(rangeControl);
